module.exports = __webpack_public_path__ + "select-arrow.dcfd45f1.svg";